import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import App from './App.jsx';
import './styles.css';

const msalInstance = new PublicClientApplication(msalConfig);

async function bootstrap() {
  // MSAL v3 requires explicit initialization before use.
  await msalInstance.initialize();

  // Set the active account after a redirect login.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Keep the active account in sync on login events.
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  // Resolve any pending login/logout redirect before rendering.
  await msalInstance.handleRedirectPromise();

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
}

bootstrap().catch((e) => {
  console.error('App bootstrap failed', e);
  document.getElementById('root').innerHTML =
    '<p style="padding:2rem;font-family:system-ui">Something went wrong starting the app. Check the console.</p>';
});
